import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StoreDetailsService {
  public store = {
    companyId: '211',
    apiUrl: 'http://154.66.198.70:3001/service_api/view_stock_complete?company_id=eq.211',
    name: 'VMG Play',
    address: '49 Blaauwberg Road, Blaauwberg, Cape Town, Western Cape, 7441',
    email: 'info@southmotorcycles.co.za',
    tel: '021 556 5494',
    instagram: 'https://www.instagram.com/vmgsoftware/',
    facebook: 'https://www.facebook.com/vmgplay.co.za/',
    eMail: {
      contactMail: 'schelton@cars4africa.co.za',
      contactMailName: 'Cars 4 Africa',
      enquireCarMail: 'schelton@cars4africa.co.za',
      enquireCarMailName: 'Cars 4 Africa',
      financeCarMail: 'schelton@cars4africa.co.za',
      financeCarMailName: 'Cars 4 Africa'
    },
    tradingHours: 'Mon-Fri: 8am - 6:00pm, Sat: 9am - 2pm',
    serverMailApi: 'https://www.vmgsoftware.co.za/ShowroomMailServiceV3/MailService.asmx/SendSimpleEmail',
    serverMailSellApi: 'https://newsendemail.vmgsoftware.co.za/api/sendemail',
    headers: new HttpHeaders({'Content-Type': 'application/json'}),
  };

  constructor() {
  }
}
